import React from "react";
import type { FollowupOption } from "@school-sales-ai/shared";

type Props = {
  options: FollowupOption[];
  onChange: (options: FollowupOption[]) => void;
  onSuggest: () => void;
  isSuggesting: boolean;
};

export function InitialOptionsEditor({ options, onChange, onSuggest, isSuggesting }: Props): React.JSX.Element {
  function handleChange(index: number, value: string): void {
    const updated = options.map((opt, i) =>
      i === index ? { label: value, prompt: value } : opt,
    );
    onChange(updated);
  }

  return (
    <div className="border-t border-ink-200 pt-4 mt-4">
      <div className="flex items-center justify-between mb-1">
        <div>
          <p className="text-[13px] font-medium text-ink-900">Opciones iniciales del widget</p>
          <p className="text-[12px] text-ink-500 mt-0.5">
            Las preguntas que aparecen como chips al abrir el chat por primera vez.
          </p>
        </div>
        <button
          type="button"
          onClick={onSuggest}
          disabled={isSuggesting}
          className="flex items-center gap-1.5 text-[12px] font-medium text-moss border border-moss rounded-lg px-3 py-1.5 hover:bg-lime-pale disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isSuggesting ? (
            <>
              <svg className="animate-spin h-3 w-3" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              Sugiriendo…
            </>
          ) : (
            <>
              <svg className="h-3 w-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
              Sugerir con IA
            </>
          )}
        </button>
      </div>

      <div className="mt-3 space-y-2">
        {options.map((opt, i) => (
          <div key={i} className="flex items-center gap-2">
            <span className="text-[12px] text-ink-400 w-4 shrink-0">{i + 1}.</span>
            <input
              type="text"
              value={opt.label}
              onChange={(e) => handleChange(i, e.target.value)}
              maxLength={200}
              placeholder={`Opción ${i + 1} — ej. ¿Qué carreras ofrecen?`}
              className="flex-1 text-[13px] border border-ink-200 rounded-lg px-3 py-1.5 focus:outline-none focus:border-moss text-ink-900 placeholder:text-ink-300 bg-white"
            />
            <span className="text-[11px] text-ink-400 w-12 text-right shrink-0">
              {opt.label.length}/200
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
